import React from 'react';

export function Loading({ label = 'Loading…' }) {
  return (
    <div className="empty">
      <div className="spin" />
      <span>{label}</span>
    </div>
  );
}

export function Empty({ label = 'No results found.' }) {
  return (
    <div className="empty">
      <b>{label}</b>
    </div>
  );
}

export function ErrorBox({ error }) {
  const msg = error?.data?.detail || error?.data?.error || error?.message || String(error);
  return (
    <div className="empty" style={{ color: 'var(--red)' }}>
      <b>Request failed</b>
      {msg}
    </div>
  );
}
